import styled from '@emotion/styled';

export const ErrorBoundaryContainer = styled.div(() => {
  return {
    height: '100%',
    width: '100%',
    display: 'flex',
    padding: '40px 0',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
  };
});

export const ErrorBoundaryContentWrapper = styled.div(() => {
  return {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: 560,
    padding: 16,
  };
});

export const ErrorBoundaryContent = styled.div(() => {
  return {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  };
});

export const ErrorBoundaryTitle = styled.h1(() => {
  return {
    fontFamily: 'Work Sans, sans-serif',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '130%',
    textAlign: 'center',
  };
});

export const ErrorBoundaryWarning = styled.div(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '14px',
    lineHeight: '150%',
    alignItems: 'center',
    textAlign: 'center',
  };
});
